const topScroll = () => {
  const param = window.location.hash.substring(1);

  if (param) {
    window.addEventListener('load', function () {
      document.querySelector('#' + param)?.scrollIntoView();
    });
  }
};

export default topScroll;
